/**
 * Validates Step 3 "Lokalita" fields.
 * Required: locationName, zip, city, firstName, lastName, phone.
 * Optional: ico, dic, icDph, street.
 * PSČ: digits and spaces (SK format e.g. "123 45").
 * Telefón: +, digits, spaces (basic).
 */
export function validateStep3(values) {
  const errors = {};

  const locationName = (values.locationName ?? "").toString().trim();
  if (!locationName) errors.locationName = "Povinné pole.";

  const zip = (values.zip ?? "").toString().trim();
  if (!zip) {
    errors.zip = "Povinné pole.";
  } else if (!/^[\d\s]+$/.test(zip)) {
    errors.zip = "PSČ môže obsahovať len číslice a medzery.";
  }

  const city = (values.city ?? "").toString().trim();
  if (!city) errors.city = "Povinné pole.";

  const firstName = (values.firstName ?? "").toString().trim();
  if (!firstName) errors.firstName = "Povinné pole.";

  const lastName = (values.lastName ?? "").toString().trim();
  if (!lastName) errors.lastName = "Povinné pole.";

  const phone = (values.phone ?? "").toString().trim();
  if (!phone) {
    errors.phone = "Povinné pole.";
  } else if (!/^[\d+\s-]+$/.test(phone)) {
    errors.phone = "Telefón môže obsahovať len číslice, +, medzery a pomlčky.";
  }

  return errors;
}
